"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// For the reducers
/* eslint-disable no-param-reassign */
exports.reducerOnRequest = function (state) {
    state.isLoading = true;
};
exports.reducerOnSuccess = function (state, responseData) {
    var _a;
    state.isLoading = false;
    // Nullify the error state on a successful api response so that user can scroll more rails
    // in subsequent attemtps. Enhance when implementing https://skynz.atlassian.net/browse/SAAA-4881
    state.error = null;
    state.pageInfo = responseData.pageInfo;
    if (Array.isArray(responseData === null || responseData === void 0 ? void 0 : responseData.content)) {
        state.content = state.content || [];
        (_a = state.content).push.apply(_a, responseData.content);
    }
};
exports.reducerOnFailure = function (state, error) {
    state.isLoading = false;
    // UPDATE: due to implementation on native-app error somehow should be set to null after a shot pause
    // as there is no way for user to do it by scrolling back like in WEB
    state.error = error;
};
/* eslint-enable no-param-reassign */
exports.getContent = function (data) { return data === null || data === void 0 ? void 0 : data.content; };
exports.isLoading = function (data) { return !!(data === null || data === void 0 ? void 0 : data.isLoading); };
exports.isLoadingError = function (data) { return !!(data === null || data === void 0 ? void 0 : data.error); };
exports.hasNextPage = function (data) { return !!(data === null || data === void 0 ? void 0 : data.pageInfo.hasNextPage); };
//# sourceMappingURL=Pagination.js.map